"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateUserRole = validateUserRole;
exports.validateUserRoles = validateUserRoles;

var _jsonwebtoken = _interopRequireDefault(require("jsonwebtoken"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-next-line import/prefer-default-export
function validateUserRole({
  role,
  getters,
  unauthorizedPage
}) {
  return (to, from, next) => {
    try {
      const idToken = getters['authentication/idToken'];

      const decoded = _jsonwebtoken.default.decode(idToken);

      const hasAccess = decoded.roles.reduce((acc, cur) => {
        if (acc) return true;
        return cur.name === role;
      }, false);

      if (!hasAccess) {
        return next(unauthorizedPage);
      }

      return next();
    } catch (error) {
      return next(unauthorizedPage);
    }
  };
} // eslint-disable-next-line import/prefer-default-export


function validateUserRoles({
  roles,
  getters,
  unauthorizedPage
}) {
  return (to, from, next) => {
    try {
      const idToken = getters['authentication/idToken'];

      const decoded = _jsonwebtoken.default.decode(idToken);

      const hasAccess = decoded.roles.reduce((acc, cur) => {
        if (acc) return true;
        return roles.includes(cur.name);
      }, false);

      if (!hasAccess) {
        return next(unauthorizedPage);
      }

      return next();
    } catch (error) {
      return next(unauthorizedPage);
    }
  };
}